<div class="card shadow-sm rounded-lg flex flex-col h-full">
  <div class="card-header border-bottom py-3 px-6 font-medium rounded-t-lg">
    Licenses
  </div>
  <div class="card-body p-6 flex-grow overflow-auto">
    <kendo-grid
      [kendoGridBinding]="repState.repLicenses"
      (edit)="editHandler($event)"
      (add)="addHandler($event)"
      (save)="saveHandler($event)"
      (cancel)="cancelHandler($event)"
      (remove)="removeHandler($event)"
    >
      <ng-template kendoGridToolbarTemplate>
        <button gdAdminOnly
          type="button"
          kendoGridAddCommand
          kendoButton
          [icon]="'plus'"
          [themeColor]="'primary'"
          class="mr-2"
        >
          Add New Record
        </button>
        <button gdAdminOnly
          type="button"
          kendoButton
          [icon]="'refresh'"
          class="ml-auto"
        >
          Refresh
        </button>
      </ng-template>
      <kendo-grid-column field="licenseType" title="License Type" width="300">
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-dropdownlist
            class="w-full"
            [data]="activeLicenseList"
            textField="licenseType"
            valueField="licenseID"
            valuePrimitive="true"
            [formControl]="formGroup.get('licenseID')"
            required
          >
          </kendo-dropdownlist>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column title="Command" width="175" gdAdminOnly>
        <ng-template
          kendoGridCellTemplate
          let-isNew="isNew"
          let-dataItem="dataItem"
        >
          <button kendoButton [themeColor]="'primary'" kendoGridEditCommand class="mr-2" gdAdminOnly>
            <span class="k-icon k-i-edit"></span>
            Edit
          </button>
          <button kendoButton [themeColor]="'error'" kendoGridRemoveCommand *ngIf="dataItem.active" class="mr-2" gdAdminOnly>
            <span class="k-icon k-i-delete"></span>
            Remove
          </button>
          <button kendoButton [themeColor]="'success'" kendoGridSaveCommand [disabled]="formGroup?.invalid" class="mr-2" gdAdminOnly>
            <span class="k-icon k-i-save"></span>
            Save
          </button>
          <button kendoButton kendoGridCancelCommand>
            <span class="k-icon k-i-cancel"></span>
            Cancel
          </button>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
</div>
